<template>
  <ul
    :id="id"
    class="dropdown menu tender-dropdown"
    data-dropdown-menu
    data-disable-hover="true"
    data-click-open="true"
    data-close-on-click="true"
  >
    <li>
      <i
        class="fa fa-ellipsis-v tender-ellipsis-size mouse-over-finger"
        aria-hidden="true"
      />
      <ul
        :id="`tender-ellipsis-bg-${id}`"
        class="menu tender-ellipsis-bg"
        :class="className"
      >
        <slot>
          <li>
            <a>{{ $t('addOption') }}</a>
            <a>{{ $t('deleteOption') }}</a>
          </li>
        </slot>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'DottedDropdown',
  props: {
    id: {
      type: String,
      required: true,
    },
    className: {
      type: String,
    },
  },
  mounted () {
    this.dropdown = new Foundation.DropdownMenu($(`#${this.id}`))
    $(`#${this.id}`).on('show.zf.dropdownmenu', () => {
      const windowHeight = $(window).height()
      const offsetTop = this.$el.getBoundingClientRect().top
      const selfHeight = $(this.$el).height() + $(this.$el).find(`#tender-ellipsis-bg-${this.id}`).height()
      let distanceToBottom = windowHeight - offsetTop - selfHeight
      if (distanceToBottom < 0) {
        $(`#tender-ellipsis-bg-${this.id}`).addClass('up-list')
      }
    })
  },
  destroyed () {
    const hideOptionsClasses = 'submenu is-dropdown-submenu first-sub vertical'
    if (this.dropdown) {
      this.dropdown.destroy()
      $(`#${this.id}`).off('show.zf.dropdownmenu')
      $(`#tender-ellipsis-bg-${this.id}`).removeClass(hideOptionsClasses).addClass(hideOptionsClasses)
    }
  },
}
</script>

<style scoped lang="scss">
.tender-ellipsis-size {
  margin: 5px 10px;
  color: #33698f;
  font-size: 25px;
  font-weight: lighter;
}

.dropdown.menu {
  & > li.opens-left {
    & > .is-dropdown-submenu.up-list {
      top: auto;
      bottom: 100%
    }
  }
}

.tender-ellipsis-bg {
  margin: 0;
  padding: 0;
  border-radius: 2px;
  background-color: #1a557d;
  // box-shadow: 0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22);
  border-style: solid;
  border-width: 0.5px;
  border-image-source: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4) 5%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0));
  border-image-slice: 1;
  min-width: auto;
  white-space:nowrap;

  li>a {
    font-family: Verdana;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    color: white;
    padding: 0.65em 1em;
  }
}

.mouse-over-finger {
  cursor: pointer;
  cursor: hand;
}
</style>
